import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner, AdPartnerBlueprint } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type {
  DeleteInternalPartnerRequestActionPayload,
  DeleteInternalPartnerResponseActionPayload,
} from '../AdPartner.types';

const DeleteInternalPartner = new ReduxAsyncAction<
  'AD_PARTNER_DELETE_INTERNAL',
  DeleteInternalPartnerRequestActionPayload,
  DeleteInternalPartnerResponseActionPayload
>('AD_PARTNER_DELETE_INTERNAL');

DeleteInternalPartner.registerRequest(async ({ partner }) => {
  const params = partner
    ? {
        params: {
          app_id: partner.app_id,
        },
      }
    : {};

  await dash_api.delete<void>(`/v1/ad-networks/app/${partner.machine_name}`, params);
  const { data: enabledPartners } = await dash_api.get<AdPartner[]>('/v1/ad-networks/app');
  const { data: partnerBlueprint } = await dash_api.get<AdPartnerBlueprint>(
    `/v1/ad-networks/global/${partner.machine_name}`
  );

  return {
    partner,
    partnerBlueprint,
    enabledPartners,
  };
});

export const DELETE_INTERNAL_PARTNER = DeleteInternalPartner.actionNamespaceConstants;

export const deleteInternalPartner = DeleteInternalPartner.request;

export type DeleteInternalPartnerResponseAction = Action<typeof DELETE_INTERNAL_PARTNER.response> & {
  data: DeleteInternalPartnerRequestActionPayload;
};
